
import filters from './filter'
import store from "../store/index";
const variableList =  [
  {
    key: '#CustomerName#',
    value: '#消费者昵称#'
  },
  {
    key: '#CommentLink#',
    value: '#评价链接#'
  },
  {
    key: '#CSContact#',
    value: '#客服昵称#'
  },
  {
    key: '#ActivityName#',
    value: '#活动名称#'
  },
  {
    key: '#WareTitle#',
    value: '#商品名称#'
  },
  {
    key: '#PayLink#',
    value: '#付款链接#'
  },
  {
    key: '#OrderId#',
    value: '#订单编号#'
  },
  {
    key: '#Logistics#',
    value: '#物流#'
  },
  {
    key: '#LogisticsNumber#',
    value: '#物流单号#'
  },
  {
    key: '#ShopName#',
    value: '#店铺名称#'
  },
  {
    key: '#OrderContent#',
    value: '#订单内容#'
  },
  {
    key: '#ShopLink#',
    value: '#店铺连接#'
  },
  {
    key: '#CouponLink#',
    value: '#领券链接#'
  },
  {
    key: '#OrderTime#',
    value: '#下单时间#'
  },
  {
    key: '#OrderAmount#',
    value: '#订单金额#'
  },
  {
    key: '#Freight Cost#',
    value: '#邮费#'
  },
  {
    key: '#itemlink#',
    value: '#商品链接#'
  },
  {
    key: '#LandingPage#',
    value: '#自定义链接#'
  }
];

const areaArea = [
  {name:"北京", code:"1", title: '北京'},
   {name:"天津", code:"2", title: '天津'},
   {name:"河北", code:"3", title: '河北省'},
   {name:"山西", code:"4", title: '山西省'},
   {name:"内蒙古",code: "5", title: '内蒙古自治区'},
   {name:"辽宁", code:"6", title: '辽宁省'},
   {name:"吉林", code:"7", title: '吉林省'},
   {name:"黑龙江", code:"8", title: '黑龙江省'},
   {name:"上海", code:"9", title: '上海'},
   {name:"江苏", code:"10", title: '江苏省'},
   {name:"浙江", code:"11", title: '浙江省'},
   {name:"安徽", code:"12", title: '安徽省'},
   {name:"福建", code:"13", title: '福建省'},
   {name:"江西", code:"14", title: '江西省'},
   {name:"山东", code:"15", title: '山东省'},
   {name:"河南", code:"16", title: '河南省'},
   {name:"湖北", code:"17", title: '湖北省'},
   {name:"湖南", code:"18", title: '湖南省'},
   {name:"广东", code:"19", title: '广东省'},
   {name:"广西", code:"20", title: '广西壮族自治区'},
   {name:"海南", code:"21", title: '海南省'},
   {name:"重庆", code:"22", title: '重庆'},
   {name:"四川", code:"23", title: '四川省'},
   {name:"贵州", code:"24", title: '贵州省'},
   {name:"云南", code:"25", title: '云南省'},
   {name:"西藏", code:"26", title: '西藏自治区'},
   {name:"陕西", code:"27", title: '陕西省'},
   {name:"甘肃", code:"28", title: '甘肃省'},
   {name:"青海", code:"29", title: '青海省'},
   {name:"宁夏", code:"30", title: '宁夏回族自治区'},
   {name:"新疆", code:"31", title: '新疆维吾尔自治区'},
   {name:"台湾", code:"32", title: '台湾'},
   {name:"港澳", code:"36", title: '港澳'},
  //  {name:"香港", code:"33", title: '香港特别行政区'},
  //  {name:"澳门", code:"34", title: '澳门特别行政区'},
   {name:"海外", code:"35", title: '海外'},]
export default{
    install(Vue) {
        /** 注册插件 */
        for (let key in filters) {
          Vue.filter(key, filters[key])
        }
        /**
         *去除对象空属性
         */
        function isEmpty(obj) {
            return (Object.keys(obj).length === 0 && obj.constructor === Object);
        }

        function deleteEmptyString(test, recurse) {

            for (var i in test) {
                if (test[i] === '' ) {
                    delete test[i];
                } else if (recurse && typeof test[i] === 'object') {
                    deleteEmptyString(test[i], recurse);
                }
            }
        }
        function deleteEmptyObject(test, recurse) {
            for (var i in test) {
                if (isEmpty(test[i]) ) {
                    delete test[i];
                } else if (recurse && typeof test[i] === 'object') {
                    deleteEmptyObject(test[i], recurse);
                }
            }
        }
        Vue.prototype.$ChineseVToEn = (content, flag) => {
          // 默认是中文转英文 flag true 表示英文转中文
          const variableList =  [
            {
              key: '#CustomerName#',
              value: '#消费者昵称#'
            },
            {
              key: '#CommentLink#',
              value: '#评价链接#'
            },
            {
              key: '#CSContact#',
              value: '#客服昵称#'
            },
            {
              key: '#ActivityName#',
              value: '#活动名称#'
            },
            {
              key: '#WareTitle#',
              value: '#商品名称#'
            },
            {
              key: '#PayLink#',
              value: '#付款链接#'
            },
            {
              key: '#OrderId#',
              value: '#订单编号#'
            },
            {
              key: '#Logistics#',
              value: '#物流#'
            },
            {
              key: '#LogisticsNumber#',
              value: '#物流单号#'
            },
            {
              key: '#ShopName#',
              value: '#店铺名称#'
            },
            {
              key: '#OrderContent#',
              value: '#订单内容#'
            },
            {
              key: '#ShopLink#',
              value: '#店铺连接#'
            },
            {
              key: '#CouponLink#',
              value: '#领券链接#'
            },
            {
              key: '#OrderTime#',
              value: '#下单时间#'
            },
            {
              key: '#OrderAmount#',
              value: '#订单金额#'
            },
            {
              key: '#Freight Cost#',
              value: '#邮费#'
            },
            {
              key: '#itemlink#',
              value: '#商品链接#'
            },
            {
              key: '#LandingPage#',
              value: '#自定义链接#'
            }
          ];
          if (content) {
            variableList.forEach(item => {
              if (flag && content.indexOf(item.key) != '-1') {
                // 英文转中文
                var reg = new RegExp(item.key, "g");
                content = content.replace(reg, item.value);
              } 
              if (!flag && content.indexOf(item.value) != '-1') {
                // 英文转中文
                var reg = new RegExp(item.value, "g")
                content = content.replace(reg, item.key)
              }
            })
          }
          return content;
        };
        
        Vue.prototype.deleteEmptyObjectFn = (test, recurse) =>{
            deleteEmptyObject(test,recurse);
        };
        /**
         *  日期格式转为字符传格式 (当前时间或者传入参数的10分钟后)
         */
        Vue.prototype.$getNowDate = (dateData, type = true) => { // 判断是否需要加10分钟
          var date = '';
          if (dateData) {
            date = dateData;
          } else {
            date = new Date();
          }
          var seperator1 = "-";
          var seperator2 = ":";
          var month = date.getMonth() + 1;
          var strDate = date.getDate();

          if (month >= 1 && month <= 9) {
            month = "0" + month;
          }
          if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
          }

          date.setMinutes(date.getMinutes() + (type ? 10 : 0));
          var Hours = date.getHours();
          var Minutes = date.getMinutes();
          var Seconds = date.getSeconds();

          if (Hours >= 0 && Hours <= 9) {
            Hours = "0" + Hours;
          }
          if (Minutes >= 0 && Minutes <= 9) {
            Minutes = "0" + Minutes;
          }
          if (Seconds >= 0 && Seconds <= 9) {
            Seconds = "0" + Seconds;
          }

          var currentdate =
            date.getFullYear() +
            seperator1 +
            month +
            seperator1 +
            strDate +
            " " +
            Hours +
            seperator2 +
            Minutes +
            seperator2 +
            Seconds;

          return currentdate;
        },

        /** 省份name=> 转code */
        Vue.prototype.provinceToCode = (name) => {
          // console.log('name:', name)
          let obj = areaArea.find(item => {
            return item.title == name
          })
          return obj.code
        },
        /**
         *传入值，返回时间段
         */
        Vue.prototype.toLongTime = (n) => {
            var n = n,
                time2 = '',
                d = new Date(),
                year = d.getFullYear(),
                mon=d.getMonth()+1,
                day=d.getDate(),
                hh = d.getHours(),
                mm = d.getMinutes(),
                ss = d.getSeconds(),
                time1 = year+"-"+(mon<10?('0'+mon):mon)+"-"+(day<10?('0'+day):day)+" "+ (hh<10?('0'+hh):hh) +":"+(mm<10?('0'+mm):mm)+":"+(ss<10?('0'+ss):ss);
            if(day <= n){
                if(mon>1) {
                    mon=mon-1;
                }
                else {
                    year = year-1;
                    mon = 12;
                }
            }
            d.setDate(d.getDate()-n);
            year = d.getFullYear();
            mon=d.getMonth()+1;
            day=d.getDate();
            // time2 = year+"-"+(mon<10?('0'+mon):mon)+"-"+(day<10?('0'+day):day)+" "+ (hh<10?('0'+hh):hh) +":"+(mm<10?('0'+mm):mm)+":"+(ss<10?('0'+ss):ss);
            time2 = year+"-"+(mon<10?('0'+mon):mon)+"-"+(day<10?('0'+day):day)+" "+ "23" +":"+"59"+":"+"59";
            return {
                oldDate:time2,
                nowDate:time1
            };
        };
        /**
         *s随机生成字符串
         * @returns {string}
         */
        Vue.prototype.getStr= () => {
            var len = len || 32;
            var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
            var maxPos = $chars.length;
            var pwd = '';
            for (var i = 0; i < len; i++) {
                pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
            }
            return pwd;
        };
        /**
         *截取字符串
         * @param str
         * @param str1
         */
        Vue.prototype.subStr = (str,str1,str2) =>{
            str.match(/【(\S*)】/)[1];
        };
        /**
         *中国标准时间转换
         * @param str
         * @returns 时间数字字符串  如20190329
         */
        Vue.prototype.ToStrTime = (time) => {
            var day1 = new Date(time);
            day1.setTime(day1.getTime());
            var yy = day1.getFullYear(),
                mm = (day1.getMonth()+1),
                dd = day1.getDate(),
                hh = day1.getHours(),
                MM = day1.getMinutes(),
                ss = day1.getSeconds();
            if(parseInt(mm)<10){
                mm = '0'+mm
            }
            if(parseInt(dd)<10){
                dd = '0'+dd
            }

            // console.log(yy+mm+dd);
            return yy+mm+dd;
        };


        /**
         *中国标准时间转换
         * @param str
         * @returns 时间数字字符串  如yyyy-mm-dd hh:mm:ss
         */
        Vue.prototype.ToStrfommat = (time) => {
            if(time==''){return '';}
            var day1 = new Date(time);
            day1.setTime(day1.getTime());
            var yy = day1.getFullYear(),
                mm = (day1.getMonth()+1),
                dd = day1.getDate(),
                hh = day1.getHours(),
                min = day1.getMinutes(),
                ss = day1.getSeconds();
            if(parseInt(mm)<10){mm = '0'+mm}
            if(parseInt(dd)<10){dd = '0'+dd}
            if(parseInt(hh)<10){hh = '0'+hh}
            if(parseInt(min)<10){min = '0'+min}
            if(parseInt(ss)<10){ss = '0'+ss}
            // console.log(yy +'-'+mm+'-'+dd+' '+hh+':'+min+':'+ss);
            return yy +'-'+mm+'-'+dd+' '+hh+':'+min+':'+ss;
        };

        //短：
        Vue.prototype.ToStrfommatShort = (time) => {
            var day1 = new Date(time);
            day1.setTime(day1.getTime());
            var yy = day1.getFullYear(),
                mm = (day1.getMonth()+1),
                dd = day1.getDate(),
                hh = day1.getHours(),
                min = day1.getMinutes(),
                ss = day1.getSeconds();
            if(parseInt(mm)<10){mm = '0'+mm}
            if(parseInt(dd)<10){dd = '0'+dd}
            if(parseInt(hh)<10){hh = '0'+hh}
            if(parseInt(min)<10){min = '0'+min}
            if(parseInt(ss)<10){ss = '0'+ss}
            // console.log(yy +'-'+mm+'-'+dd);
            return yy +'-'+mm+'-'+dd
        };


        Vue.prototype.isNullStr = str => {
            if (String(str) === '0') {
                return false
            }
            if(str === null || str === '' || str === undefined) {
                return true
            }
            return false
        }
        /*
         * @desc   判断是否为手机号
         * @param  {String|Number} str
         * @return {Boolean}
         */
        Vue.prototype.isPhoneNum = str => {
            var myreg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
            if (myreg.test(str)) {
                return true;
            } else {
                return false;
            }
        };

        /**
         *
         * @desc  判断是否为身份证号
         * @param  {String|Number} str
         * @return {Boolean}
         */
        Vue.prototype.isIdCard = str => {
            return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(str)
        };
        /**
         * 时间戳转化成日期格式
         */
        Vue.prototype.timestampToTime = timestamp => {
            let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let Y = date.getFullYear() + '-';
            let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            let D = date.getDate() + ' ';
            let h = date.getHours() + ':';
            let m = date.getMinutes() + ':';
            let s = date.getSeconds();
            return Y+M+D+h+m+s;
        };
        /**
         * 将日期格式转换成时间戳
         */
        Vue.prototype.timeToTimestamp = time => {
            let timestamp = Date.parse(new Date(time));
            timestamp = timestamp / 1000;
            return timestamp;
        };
        Vue.prototype.setStorage = (key,val) => {
            window.sessionStorage.setItem(key,val);
        }
        Vue.prototype.getHeight = () => {
            return window.screen.height;
        }
        Vue.prototype.getStorage = name => {
            if (!name) return;
            return window.sessionStorage.getItem(name);
        };
        Vue.prototype.removeStorage = name =>{
            if (!name) return;
            return window.sessionStorage.removeItem(name);
        };
        /*
        * 数组转字符串
        * */
        Vue.prototype.arrayVariableString = name => {
            // return name.join(",")
            // return namer.join("")
            return name.toString()
        };

        /***
         * 操作系统中接口返回'yyyy-MM-dd HH:mm:ss'格式的时间字符串
         * 转换为yyyy-MM-dd
         * @param dateStr
         * @returns {*}
         */
        Vue.prototype.optTime = dateStr => {
            if (dateStr) {
                return dateStr.split(' ')[0]
            }
            return ''
        }
        /***
         * 操作获取当前日期的前n天/后n天
         * @param num 第n天
         * @param separator 分隔符
         * @returns {string}
         */
        Vue.prototype.getDay = (num, separator) => {
            const today = new Date();
            const nowTime = today.getTime();
            const ms = 24 * 3600 * 1000 * num;
            today.setTime(parseInt(nowTime + ms));
            const oYear = today.getFullYear();
            let oMoth = (today.getMonth() + 1).toString();
            if (oMoth.length <= 1) oMoth = '0' + oMoth;
            let oDay = today.getDate().toString();
            if (oDay.length <= 1) oDay = '0' + oDay;
            return oYear + separator + oMoth + separator + oDay;
        }
        /* 
          用于全局时分的方法
        */
        Vue.prototype.getTimeMinutes=()=>{
            var timeMinutes = new Date();
            var getHours=timeMinutes.getHours()
            var getMinutes=timeMinutes.getMinutes()
            getHours = getHours < 10? '0'+getHours : getHours;
            getMinutes = getMinutes < 10? '0'+getMinutes : getMinutes;
            var times =  getHours+":"+getMinutes;
            return times;
        }
        //邮箱验证
        Vue.prototype.checkEmail  = (email) =>{
            var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
            if(!reg.test(email)){
                return false
            }
            else{
                return true
            }
        }

        // 获取当前日期的前n天，后n天的日期
        Vue.prototype.getDateStr  = (AddDayCount) =>{
            var dd = new Date();    
            dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期    
            var y = dd.getFullYear();    
            var m = dd.getMonth()+1;//获取当前月份的日期    
            var d = dd.getDate();    
            return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
        }

        // 处理号码为空
        Vue.prototype.Trim = function(str)  
         {  
            var result;
            result = str.replace(/(^\s+)|(\s+$)/g, "");
            result = result.replace(/\s/g, "");
            return result;
               }  

        //验证微信
        
        Vue.prototype.checkWechat  = (wechat) =>{
            var reg = new RegExp("^[a-zA-Z][a-zA-Z0-9_-]{5,19}$");
            if(!reg.test(wechat)){
                return false
            }
            else{
                return true
            }
        }
        
        //整点时间转换整数
        
        Vue.prototype.dateParam = (date)=>{
            // console.log(date);
            return Number(date.substring(0,date.indexOf(":")))
        };
        /**
         * 防抖
         * @param {Function} func
         * @param {Number} wait
         * @param {Boolean} immediate   设置为ture时，调用触发于开始边界而不是结束边界
         * @return {*}
         */
        Vue.prototype.debounce = (func, wait, immediate)=> {
            let timeout, args, context, timestamp, result
            const later = function () {
                // 据上一次触发时间间隔
                const last = +new Date() - timestamp
                // console.log('调用了later');
        
                // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
                if (last < wait && last > 0) {
                    // console.log('again');
                    
                    timeout = setTimeout(later, wait - last)
                } else {
                    timeout = null
                    // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
                    if (!immediate) {
                        // console.log(context);
                        
                        result = func.apply(context, args)
                        if (!timeout) context = args = null
                    }
                }
            }
        
            return function (...args) {
                context = this                          //保存当前this
                timestamp = +new Date()                 // 当前时间，+的作用是转Number类型
                const callNow = immediate && !timeout
                // 如果延时不存在，重新设定延时
                if (!timeout) {
                    // console.log('frist');
                    timeout = setTimeout(later, wait)
                }
                if (callNow) {
                    console.log(result);
                    result = func.apply(this, args)
                    context = args = null
                }
        
                return result
            }
        }
        //防止按钮在短时间多次点击
        // 用法：：<button v-intervalclick='{func:执行方法,time:间隔时间(毫秒数),...执行方法所需要的参数}'>点击</button> 
        let openDelay = false;
        Vue.directive('intervalclick', function(el,binding){
            el.onclick=function(e){
                if(openDelay)return;
                openDelay=!openDelay;
                if (!binding.value) {
                    alert("未传入Value数据！");
                    return;
                }
                let func = binding.value['func'];
                let time=binding.value['time'];
                if(typeof time !=='number'){
                    alert("传入等待时间错误");
                    return;
                }
                let args=[];
                for (const key in binding.value) {
                    if (binding.value.hasOwnProperty(key)) {
                        if(key==='func'||key==='time')continue;
                        args.push(binding.value[key])
                    }
                }
                setTimeout(() => {
                    openDelay=!openDelay; 
                }, time);
                func(...args);
        }
      })
      // 判断用户会否为云舟标准版
      Vue.prototype.jumpLoginPage = function(link) {
        try {
          // platformFlag 为 false 则为云舟标准版, 云舟标准版的跳转需要根据返回链接跳
          let platformFlag = true;
          if(store.getters.loginUserInfo) {
            platformFlag = store.getters.loginUserInfo.platformFlag;
          }else {
            platformFlag = true;
          }
          if(platformFlag) {
            window.open('https://yz.yqcrm.cn/login','_self');
          }else {
            window.open(link,'_self');
          }
        } catch (error) {
          window.open('https://yz.yqcrm.cn/login','_self');
        }
      }
      
      Vue.prototype.jumpLoginPage2 = function(link) {
        try {
          if(link) {
            window.open(link,'_self');
          }else {
            window.open('https://yz.yqcrm.cn/login','_self');
          }
        } catch (error) {
          window.open('https://yz.yqcrm.cn/login','_self');
        }
      }
    }
}
